import { baseBackend } from "../../../../../api/base/baseUrl";

const URL_SETTINGS = "/api/v2/settings";

export const getSettings = async () => {
  return await baseBackend.get(`${URL_SETTINGS}`, {
    headers: { "Content-Type": "application/json" },
  });
};

export const updateSettings = async (data) => {
  return await baseBackend.put(`${URL_SETTINGS}`, JSON.stringify(data), {
    headers: { "Content-Type": "application/json" },
  });
};
